import React from 'react'
import TemplateCard from '../templateCard'
import { previewUrl } from '../../helpers'

const TemplateCardMultipleImages = ({ item, isInList, className = '' }) => {
  const componentClassName = isInList ? 'flex mt-6' : 'hidden lg:flex mt-12'
  const itemWrapClassName = isInList ? 'space-x-3' : 'space-x-3'
  const cardClassName = isInList ? 'md:w-24' : 'md:w-32'

  if (!item.isArchived && item.screenshots) {
    return (
      <div className={`justify-center items-center ${componentClassName} ${className}`}>
        <div className={`flex justify-center ${itemWrapClassName}`}>
          {item.screenshots.map((screenshot, id) => (
            <TemplateCard
              key={screenshot.childImageSharp.id}
              image={screenshot}
              linkTitle={isInList ? null : `Preview ${item.longTitle}`}
              href={isInList ? null : previewUrl(item)}
              alt={item.longTitle}
              padding={1}
              className={`bg-white max-w-full ${cardClassName}`}
            />
          ))}
        </div>
        {item.hasMultipleColors && (
          <div className="ml-3">
            {isInList && <span>+15</span>}
            {!isInList && (
              <a
                href={previewUrl(item)}
                title={`Preview ${item.longTitle}`}
                className="inline-block rounded bg-white px-2 py-1 hover:text-blue-600"
              >
                +15 more&hellip;
              </a>
            )}
          </div>
        )}
      </div>
    )
  }

  return null
}

export default TemplateCardMultipleImages
